import { StyleSheet } from "react-native";

/**
 * Mobile-only (iPhone) styles for the Sustain Queue screen.
 * Applied when Platform.OS === "ios" && windowWidth < 768.
 * Does NOT affect web or iPad.
 */
const mobileSustainQueueStyles = StyleSheet.create({
  /* ── Screen root ─────────────────────────────────────────── */
  screenRoot: {
    flex: 1,
    backgroundColor: "#f0f4fa",
  },

  /* ── Header block ────────────────────────────────────────── */
  headerBlock: {
    backgroundColor: "#ffffff",
    paddingHorizontal: 16,
    paddingVertical: 14,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottomWidth: 1,
    borderBottomColor: "#ebebeb",
  },
  headerLeft: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    flex: 1,
  },
  backArrowWrap: {
    padding: 2,
  },
  headerTitleBlock: {
    flex: 1,
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: "700",
    color: "#1a2332",
    lineHeight: 26,
  },
  headerSubtitle: {
    fontSize: 12,
    color: "#818181",
    marginTop: 1,
  },
  filterIconBtn: {
    padding: 6,
    position: "relative",
  },
  filterBadge: {
    position: "absolute",
    top: 0,
    right: 0,
    minWidth: 16,
    height: 16,
    borderRadius: 8,
    backgroundColor: "#034895",
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 3,
  },
  filterBadgeText: {
    fontSize: 9,
    fontWeight: "700",
    color: "#ffffff",
    lineHeight: 12,
  },

  /* ── Toggle tabs (Kanban / List) ─────────────────────────── */
  tabsRow: {
    flexDirection: "row",
    backgroundColor: "#ffffff",
    marginHorizontal: 16,
    marginTop: 12,
    borderRadius: 10,
    padding: 3,
    borderWidth: 1,
    borderColor: "#d7e5f8",
  },
  tab: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    paddingVertical: 9,
    borderRadius: 8,
  },
  tabActive: {
    backgroundColor: "#034895",
  },
  tabText: {
    fontSize: 14,
    fontWeight: "700",
    color: "#4b4b4b",
  },
  tabTextActive: {
    color: "#ffffff",
  },

  /* ── Search bar ──────────────────────────────────────────── */
  searchWrap: {
    marginHorizontal: 16,
    marginTop: 10,
    position: "relative",
  },
  searchIcon: {
    position: "absolute",
    left: 12,
    top: 12,
    zIndex: 2,
  },
  searchInput: {
    backgroundColor: "#ffffff",
    borderWidth: 1,
    borderColor: "#d0d0d0",
    borderRadius: 10,
    paddingLeft: 38,
    paddingRight: 12,
    paddingVertical: 10,
    height: 44,
    fontSize: 14,
    color: "#2d2d2d",
  },

  /* ── Card list container ─────────────────────────────────── */
  cardList: {
    paddingHorizontal: 16,
    paddingTop: 12,
    paddingBottom: 32,
  },

  /* ── Status section header (kanban grouped view) ─────────── */
  sectionHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingVertical: 10,
    marginTop: 6,
  },
  sectionHeaderLeft: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
  sectionDot: {
    width: 10,
    height: 10,
    borderRadius: 5,
  },
  sectionLabel: {
    fontSize: 15,
    fontWeight: "700",
    color: "#2d2d2d",
  },
  sectionCountWrap: {
    backgroundColor: "#e8eef8",
    borderRadius: 100,
    paddingHorizontal: 9,
    paddingVertical: 3,
    minWidth: 24,
    alignItems: "center",
    justifyContent: "center",
  },
  sectionCount: {
    fontSize: 12,
    fontWeight: "700",
    color: "#4b4b4b",
    textAlign: "center",
  },

  /* ── Card ────────────────────────────────────────────────── */
  card: {
    backgroundColor: "#ffffff",
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "#e6edf8",
    marginBottom: 10,
    overflow: "hidden",
    position: "relative",
  },
  cardPressed: {
    opacity: 0.85,
  },
  cardLeftBorder: {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    width: 4,
    borderTopLeftRadius: 10,
    borderBottomLeftRadius: 10,
  },
  cardContent: {
    paddingLeft: 16,
    paddingRight: 12,
    paddingVertical: 12,
  },
  cardTopRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 4,
  },
  ticketId: {
    fontSize: 13,
    fontWeight: "700",
    color: "#005cbc",
  },
  ticketTitle: {
    fontSize: 14,
    fontWeight: "600",
    color: "#2d2d2d",
    marginBottom: 6,
    lineHeight: 20,
  },
  cardBottomRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 2,
    gap: 8,
  },
  assigneeRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  assigneeAvatar: {
    width: 22,
    height: 22,
    borderRadius: 11,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#7871E2",
  },
  assigneeAvatarText: {
    fontSize: 9,
    fontWeight: "700",
    color: "#ffffff",
  },
  assigneeName: {
    fontSize: 12,
    color: "#3a3a3a",
    fontWeight: "500",
  },
  unassignedChip: {
    backgroundColor: "#FFE6E4",
    borderRadius: 6,
    paddingHorizontal: 8,
    paddingVertical: 3,
  },
  unassignedChipText: {
    fontSize: 11,
    fontWeight: "700",
    color: "#C23603",
  },
  locationMeta: {
    fontSize: 12,
    color: "#656565",
    flexShrink: 1,
    textAlign: "right",
  },
  sitesText: {
    fontSize: 12,
    color: "#656565",
    marginLeft: 4,
  },

  /* ── Badge ───────────────────────────────────────────────── */
  badge: {
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 100,
  },
  badgeDot: {
    width: 7,
    height: 7,
    borderRadius: 4,
  },
  badgeText: {
    fontSize: 12,
    fontWeight: "700",
  },

  /* ── Urgency badge variants ──────────────────────────────── */
  urgencyCritical: { backgroundColor: "#FFE6E4" },
  urgencyCriticalDot: { backgroundColor: "#C23603" },
  urgencyCriticalText: { color: "#C23603" },
  urgencyHigh: { backgroundColor: "#FFE9D1" },
  urgencyHighDot: { backgroundColor: "#D0781D" },
  urgencyHighText: { color: "#C56F12" },
  urgencyMedium: { backgroundColor: "#FFF6CC" },
  urgencyMediumDot: { backgroundColor: "#8B6508" },
  urgencyMediumText: { color: "#8B6508" },
  urgencyLow: { backgroundColor: "#F3F4F6" },
  urgencyLowDot: { backgroundColor: "#6B7280" },
  urgencyLowText: { color: "#6B7280" },

  /* ── Status badge variants (list view) ───────────────────── */
  statusNew: { backgroundColor: "#DCE8FB" },
  statusNewText: { color: "#005CBC" },
  statusProgress: { backgroundColor: "#E4E0FD" },
  statusProgressText: { color: "#5C4EC9" },
  statusWaitingIt: { backgroundColor: "#FFF6CC" },
  statusWaitingItText: { color: "#8B6508" },
  statusWaitingTmv: { backgroundColor: "#FFF6CC" },
  statusWaitingTmvText: { color: "#8B6508" },
  statusSubmittedAdo: { backgroundColor: "#FFE9D1" },
  statusSubmittedAdoText: { color: "#D0781D" },
  statusWaitingUser: { backgroundColor: "#FFF6CC" },
  statusWaitingUserText: { color: "#8B6508" },
  statusResolved: { backgroundColor: "#F3F4F6" },
  statusResolvedText: { color: "#6B7280" },

  /* ── Filter sheet ────────────────────────────────────────── */
  sheetOverlay: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.4)",
    justifyContent: "flex-end",
  },
  sheetContainer: {
    backgroundColor: "#ffffff",
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    maxHeight: "90%",
    paddingBottom: 24,
  },
  sheetHandle: {
    width: 40,
    height: 4,
    borderRadius: 2,
    backgroundColor: "#d0d0d0",
    alignSelf: "center",
    marginTop: 10,
    marginBottom: 4,
  },
  sheetHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 20,
    paddingVertical: 14,
    borderBottomWidth: 1,
    borderBottomColor: "#f0f0f0",
  },
  sheetTitle: {
    fontSize: 18,
    fontWeight: "700",
    color: "#1a2332",
  },
  sheetClearAll: {
    fontSize: 14,
    fontWeight: "600",
    color: "#034895",
  },
  /* Dark header variant (used in redesigned filter sheet) */
  sheetHeaderDark: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 16,
    paddingVertical: 14,
    backgroundColor: "#1a2332",
  },
  filterFullScreen: {
    flex: 1,
    backgroundColor: "#f8f9fa",
  },
  sheetCloseBtn: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: "rgba(255,255,255,0.15)",
    alignItems: "center",
    justifyContent: "center",
  },
  sheetTitleDark: {
    fontSize: 18,
    fontWeight: "700",
    color: "#ffffff",
  },
  sheetClearAllDark: {
    fontSize: 14,
    fontWeight: "700",
    color: "#4ea8f5",
  },
  sheetScrollContent: {
    paddingHorizontal: 20,
    paddingTop: 8,
    paddingBottom: 12,
  },
  filterSection: {
    marginBottom: 18,
  },
  filterSectionLabel: {
    fontSize: 12,
    fontWeight: "700",
    color: "#1a2332",
    letterSpacing: 0.6,
    marginBottom: 10,
  },
  filterChipRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  filterChip: {
    borderWidth: 1,
    borderColor: "#d0d0d0",
    borderRadius: 100,
    paddingHorizontal: 14,
    paddingVertical: 8,
    backgroundColor: "#ffffff",
  },
  filterChipActive: {
    borderColor: "#034895",
    backgroundColor: "#034895",
  },
  filterChipText: {
    fontSize: 13,
    fontWeight: "600",
    color: "#3a3a3a",
  },
  filterChipTextActive: {
    color: "#ffffff",
  },

  /* ── Location dropdown ───────────────────────────────────── */
  filterDropdownWrap: {
    borderWidth: 1,
    borderColor: "#d0d0d0",
    borderRadius: 10,
    backgroundColor: "#ffffff",
    paddingHorizontal: 14,
    paddingVertical: 12,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  filterDropdownText: {
    fontSize: 14,
    color: "#2d2d2d",
  },
  filterDropdownList: {
    borderWidth: 1,
    borderColor: "#d0d0d0",
    borderRadius: 10,
    backgroundColor: "#ffffff",
    marginTop: 4,
    overflow: "hidden",
  },
  filterDropdownItem: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    paddingHorizontal: 14,
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: "#f0f0f0",
    backgroundColor: "#ffffff",
  },
  filterDropdownItemSelected: {
    backgroundColor: "#f0f4fa",
  },
  filterDropdownItemText: {
    fontSize: 14,
    color: "#1a2332",
  },
  filterDropdownItemTextSelected: {
    color: "#034895",
    fontWeight: "600",
  },

  /* ── Filter sheet footer ─────────────────────────────────── */
  sheetFooter: {
    paddingHorizontal: 20,
    paddingTop: 12,
     borderTopWidth: 1,
    borderTopColor: "#f0f0f0",
  },
  sheetFooterClearAll: {
    paddingVertical: 8,
    marginBottom: 4,
  },
  sheetFooterClearAllText: {
    fontSize: 14,
    fontWeight: "700",
    color: "#374151",
  },
  applyBtn: {
    backgroundColor: "#034895",
    borderRadius: 100,
    paddingVertical: 15,
    alignItems: "center",
  },
  applyBtnPressed: {
    backgroundColor: "#023070",
  },
  applyBtnText: {
    color: "#ffffff",
    fontSize: 16,
    fontWeight: "700",
  },
});

/** Left accent border colour per status key */
export const STATUS_LEFT_BORDER_COLOR: Record<string, string> = {
  new: "#005CBC",
  progress: "#7871E2",
  "waiting-it": "#FCC42B",
  "waiting-tmv": "#FCC42B",
  "submitted-ado": "#FF8C09",
  "waiting-user": "#FCC42B",
  resolved: "#6B7280",
};

/** Dot colour per status key (for section headers) */
export const STATUS_DOT_COLOR: Record<string, string> = {
  new: "#005CBC",
  progress: "#7871E2",
  "waiting-it": "#FCC42B",
  "waiting-tmv": "#FCC42B",
  "submitted-ado": "#FF8C09",
  "waiting-user": "#FCC42B",
  resolved: "#6B7280",
};

export default mobileSustainQueueStyles;
